import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ProductService } from "../../shared/services/product.service";
import { ParamMap, NavigationEnd } from "@angular/router";
import { Product } from "../../shared/classes/product";
import { ViewportScroller } from "@angular/common";
import { CommonService } from "src/app/shared/services/common.service";

// declare let fbq: Function;

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"],
})
export class SearchComponent implements OnInit {
  public query = "";
  public nodata: boolean = false;
  public allItems: Product[] = [];
  public layoutView: string = "grid-view";
  public grid: string = "col-xl-3 col-md-6";
  public finished: boolean = false; // boolean when end of data is reached
  public all_products: any[] = [];
  public allShownProducts = [];
  public products: any[] = [];
  public brands: any[] = [];
  public colors: any[] = [];
  public size: any[] = [];
  public minPrice: number = 0;
  public maxPrice: number = 1200;
  public tags: any[] = [];
  public category: string;
  public pageNo: number = 1;
  public paginate: any = {}; // Pagination use only
  public sortBy: string; // Sorting Order
  public mobileSidebar: boolean = false;
  public loader: boolean = true;
  public addItemCount = 8;
  public start = 0;
  fetchedIds: Set<any> = new Set();
  loading: boolean = true;
  loadingImgUrl: string = "";
  public getNoData: boolean = false;
  page_name = localStorage.getItem("front-lang") == "ar" ? "بحث" : "Search";
  search_name: string = "";
  currentRoute;
  FormShapesLabels: any;
  loadingmore: boolean = false;
  totalCount: number = 0;
  searchkey: string = "";
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public productService: ProductService,
    private viewScroller: ViewportScroller,
    private Common: CommonService
  ) {
    // SET TITLE
    this.Common.setTitle(this.page_name);

    this.currentRoute = router.url.split("/");
    // //console.log("Params", this.currentRoute);
    this.route.queryParams.subscribe((params) => {
      // //console.log("Params", params);
      this.products = [];
      this.finished = false;

      this.brands = params.brand ? params.brand.split(",") : [];
      this.colors = params.color ? params.color.split(",") : [];
      this.size = params.size ? params.size.split(",") : [];
      this.minPrice = params.minPrice ? params.minPrice : this.minPrice;
      this.maxPrice = params.maxPrice ? params.maxPrice : this.maxPrice;
      this.tags = [...this.brands, ...this.colors, ...this.size]; // All Tags Array

      this.category = params.category ? params.category : null;
      this.sortBy = params.sortBy ? params.sortBy : "ascending";
      // Get Filtered Products..
      this.productService.filterProducts(this.tags).subscribe((response) => {
        // All Products
        this.all_products = response;
        // Sorting Filter
        this.all_products = this.productService.sortProducts(
          response,
          this.sortBy
        );

        // Category Filter
        if (params.category)
          this.all_products = this.all_products.filter(
            (item) => item.type == this.category
          );

        // Price Filter
        this.all_products = this.all_products.filter(
          (item) => item.price >= this.minPrice && item.price <= this.maxPrice
        );

        this.addItems();
      });
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: ParamMap) => {
      this.allShownProducts = [];
      this.start = 0;
      this.loading = true;
      this.finished = false;
      // //console.log("Params", params)
      this.query = params["search"];
      this.searchkey = params["mode"];
      this.search_name =
        localStorage.getItem("front-lang") == "ar"
          ? `نتائج البحث عن: ${this.query}`
          : `Search results for: ${this.query}`;

      // CODE PIXEL TAG
      // fbq("track", "Search", {
      //   search_string: this.query,
      // });
      // //console.log(this.query);

      if (this.query != "") {
        this.getSearchProductData();
      }
    });
  }
  formShapesMode: boolean = false;
  getSearchProductData() {
    this.loading = true;
    this.finished = false;
    let searchMode = this.currentRoute[2];
    // //console.log(searchMode);
    searchMode == "formshapes"
      ? (this.formShapesMode = true)
      : (this.formShapesMode = false);

    let body = {
      prod_ids: [],
      form_shape: [],
      searchMultiPrices: [],
    };
    this.loading = true;
    this.finished = false;
    this.getNoData = false;
    this.productService
      .getProductsPayParams(
        "",
        this.query,
        "",
        "",
        body,
        this.start,
        25,
        "",
        "",
        [],
        this.formShapesMode ? "formshapes" : ""
      )
      .subscribe((products) => {
        // //console.log(products);
        //console.log("search", this.query);

        if (products.data) {
          if (this.start == 0) {
            this.allItems = [];
            this.allShownProducts = [];
            this.fetchedIds.clear();
          }

          products.data.forEach((product) => {
            if (!this.fetchedIds.has(product.id)) {
              this.fetchedIds.add(product.id);
              this.allItems.push(product);
              //console.log(this.allItems);
            }
          });

          this.all_products = this.allItems;
          this.allShownProducts = this.allItems;
          this.loading = false;
          this.finished = true;
          if (this.start == 0 && this.searchkey == "web") {
            this.getSearchProductCount(this.query);
          }
          if (this.allItems.length == 0) {
            this.getNoData = true;
          }
        } else {
          this.getNoData = true;
          this.loading = false;
          this.allItems = [];
          this.finished = true;
        }
      });
  }
  getSearchProductCount(query) {
    this.productService.getSearchProductCount("", query).subscribe((data) => {
      //console.log("dataaa", data);
      this.totalCount = data.total_count;
      this.ProductReports();
    });
  }

  ProductReports() {
    this.productService
      .addSearchProductReports(this.query, this.totalCount)
      .subscribe((res) => {});
  }

  // loadMoreProducts() {
  //   this.loadingmore = true;

  //   let body = {
  //     prod_ids: [],
  //     form_shape: [],
  //     searchMultiPrices: [],
  //   };

  //   let offset = this.allItems.length;
  //   //console.log(offset)

  //   this.productService
  //     .getProductsPayParams(
  //       "",
  //       this.query,
  //       "",
  //       "",
  //       body,
  //       offset,
  //       25,
  //       "",
  //       "",
  //       [],
  //       this.formShapesMode ? "formshapes" : ""
  //     )
  //     .subscribe((products) => {
  //       if (products.data) {
  //         products.data.forEach((product) => {
  //           if (!this.fetchedIds.has(product.id)) {
  //             this.fetchedIds.add(product.id);
  //             this.allItems.push(product);
  //           }
  //         });
  //       }

  //       this.loadingmore = false;
  //       this.finished = !products.data || products.data.length === 0;
  //     });
  // }

  // @HostListener("window:scroll", ["$event"])
  // onWindowScroll() {
  //   if (
  //     window.innerHeight + window.scrollY >= document.body.offsetHeight
  //   ) {
  //     this.loadMoreProducts();
  //   }
  // }

  goToSearch() {
    this.nodata = false;
    if (this.query != "") {
      this.router.navigate(["/pages/search/" + this.query]);
    }
  }

  // Change Layout View
  updateLayoutView(value: string) {
    this.layoutView = value;
    if (value == "list-view") this.grid = "col-lg-12";
    else this.grid = "col-xl-3 col-md-6";
  }

  addItems() {
    if (
      this.all_products.length <= this.products.length &&
      this.all_products.length <= this.addItemCount
    ) {
      this.finished = true;
      return;
    }
    this.products = this.all_products.slice(0, this.addItemCount);
  }
  // Infinite scroll
  public onScroll() {
    // add another items
    this.addItemCount += 8;
    this.addItems();

    this.start += 25;
    this.getSearchProductData();
  }

  // Append filter value to Url
  updateFilter(tags: any) {
    this.allShownProducts = [];
    this.start = 0;
    tags.page = null; // Reset Pagination
    this.router
      .navigate([], {
        relativeTo: this.route,
        queryParams: tags,
        queryParamsHandling: "merge", // preserve the existing query params in the route
        skipLocationChange: false, // do trigger navigation
      })
      .finally(() => {
        this.viewScroller.setOffset([120, 120]);
        this.viewScroller.scrollToAnchor("products"); // Anchore Link
      });
  }

  // SortBy Filter
  sortByFilter(value) {
    this.router
      .navigate([], {
        relativeTo: this.route,
        queryParams: { sortBy: value ? value : null },
        queryParamsHandling: "merge", // preserve the existing query params in the route
        skipLocationChange: false, // do trigger navigation
      })
      .finally(() => {
        this.viewScroller.setOffset([120, 120]);
        this.viewScroller.scrollToAnchor("products"); // Anchore Link
      });
  }

  // Remove Tag
  removeTag(tag) {
    this.brands = this.brands.filter((val) => val !== tag);
    this.colors = this.colors.filter((val) => val !== tag);
    this.size = this.size.filter((val) => val !== tag);

    let params = {
      brand: this.brands.length ? this.brands.join(",") : null,
      color: this.colors.length ? this.colors.join(",") : null,
      size: this.size.length ? this.size.join(",") : null,
    };

    this.router
      .navigate([], {
        relativeTo: this.route,
        queryParams: params,
        queryParamsHandling: "merge", // preserve the existing query params in the route
        skipLocationChange: false, // do trigger navigation
      })
      .finally(() => {
        this.viewScroller.setOffset([120, 120]);
        this.viewScroller.scrollToAnchor("products"); // Anchore Link
      });
  }

  // Clear Tags
  removeAllTags() {
    this.router
      .navigate([], {
        relativeTo: this.route,
        queryParams: {},
        skipLocationChange: false, // do trigger navigation
      })
      .finally(() => {
        this.viewScroller.setOffset([120, 120]);
        this.viewScroller.scrollToAnchor("products"); // Anchore Link
      });
  }

  // Change Grid Layout
  updateGridLayout(value: string) {
    this.grid = value;
  }

  // Mobile sidebar
  toggleMobileSidebar() {
    this.mobileSidebar = !this.mobileSidebar;
  }
}
